import {
  ActionIcon, ICON_TRASH_CAN_OUTLINE, Portal, useModal, useNotifications, ConfirmModal,
} from '@doveit/bricks';
import React from 'react';
import { deleteHRCalendarEvent } from '../../../providers/api/hr/hrProvider';

interface ChildFnProps {
  isSaving?: boolean,
  openModal?: VoidFunction,
}

export interface DeleteHRCalendarEventActionProps {
  hrCalendarEventId: string,
  onSuccess?: (hrCalendarEventId: string) => void,
  children?: (props: ChildFnProps) => React.ReactNode,
}

export const DELETE_HR_CALENDAR_EVENT_SUCCESS_MESSAGE = 'L\'evento a calendario è stato eliminato con successo';
export const DELETE_HR_CALENDAR_EVENT_ERROR_MESSAGE = "Errore durante l'eliminazione dell'evento a calendario";

const DeleteHRCalendarEventAction: React.FC<DeleteHRCalendarEventActionProps> = ({
  hrCalendarEventId,
  onSuccess,
  children,
}) => {
  const [isSaving, setIsSaving] = React.useState(false);
  const { addSuccess, addError } = useNotifications();
  const modal = useModal();

  const handleConfirm = React.useCallback(async () => {
    setIsSaving(true);

    try {
      await deleteHRCalendarEvent(hrCalendarEventId);

      setIsSaving(false);

      addSuccess(DELETE_HR_CALENDAR_EVENT_SUCCESS_MESSAGE);
      modal.close();
      onSuccess?.(hrCalendarEventId);
    } catch (err) {
      setIsSaving(false);
      addError(DELETE_HR_CALENDAR_EVENT_ERROR_MESSAGE);
    }
  }, [hrCalendarEventId, addSuccess, modal, onSuccess, addError]);

  return (
    <>
      {children
        ? children({
          isSaving,
          openModal: () => modal.open(),
        })
        : (
          <ActionIcon
            icon={{ path: ICON_TRASH_CAN_OUTLINE }}
            aria-label="Azione per eliminare l'evento a calendario"
            label="Elimina"
            size="S"
            onClick={() => modal.open()}
            loading={isSaving}
          />
        )}
      <Portal>
        <ConfirmModal
          {...modal}
          saving={isSaving}
          aria-label="Modale per eliminare l'evento a calendario"
          title="Conferma eliminazione evento a calendario"
          onConfirm={handleConfirm}
          onAbort={() => modal.close()}
          variant="critical"
        >
          Confermando l&apos;azione, l&apos;evento a calenario sarà eliminato.
        </ConfirmModal>
      </Portal>
    </>
  );
};

export default DeleteHRCalendarEventAction;
